import React from 'react';
import { Arrow } from '../../Icons';

export const Next = ({ nextSlide }: { nextSlide: () => void }) => (
    <div className="FeaturedArtists-carousel-next u-hidden-lg-down" onClick={nextSlide}>
        <Arrow size="large" />
    </div>
);
